"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNING_METHODS = exports.LOGIN_METHODS = void 0;
const config_1 = require("../config");
const methods = {
    SMART_ID: config_1.AuthMethod.SMART_ID,
    MOBILE_ID: config_1.AuthMethod.MOBILE_ID,
    ID_CARD: config_1.AuthMethod.ID_CARD,
    CUSTOMER_ID: config_1.AuthMethod.CUSTOMER_ID,
    CUSTOMER_DEVICE: config_1.AuthMethod.CUSTOMER_DEVICE,
    BANK_ID: config_1.AuthMethod.BANK_ID,
    SIGNICAT: config_1.AuthMethod.SIGNICAT,
    EVROTRUST: config_1.AuthMethod.EVROTRUST,
    EPARAKSTS: config_1.AuthMethod.EPARAKSTS
};
exports.LOGIN_METHODS = Object.freeze(methods);
exports.SIGNING_METHODS = Object.freeze(methods);
